import type { NoteColor } from '@keep/shared';
import { Check, DropletOff } from 'lucide-react';
import { cn } from '../../lib/cn';
import { NOTE_COLOR_OPTIONS, noteColorVar } from '../../lib/colors';

/** Palette de couleurs de Keep, utilisée dans un popover. */
export function ColorPicker({
  value,
  onChange,
}: {
  value: NoteColor | null;
  onChange: (color: NoteColor) => void;
}) {
  return (
    <div
      role="radiogroup"
      aria-label="Couleur de la note"
      className="flex max-w-[300px] flex-wrap gap-1 p-2 sm:max-w-none"
    >
      {NOTE_COLOR_OPTIONS.map(({ id, label }) => {
        const selected = value === id;
        return (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={label}
            title={label}
            onClick={() => onChange(id)}
            style={{ backgroundColor: noteColorVar(id) }}
            className={cn(
              'relative flex size-8 items-center justify-center rounded-full border-2 transition-colors',
              selected
                ? 'border-[#a142f4]'
                : id === 'default'
                  ? 'border-line hover:border-fg'
                  : 'border-transparent hover:border-fg',
            )}
          >
            {id === 'default' && !selected && (
              <DropletOff size={16} className="text-muted" aria-hidden />
            )}
            {selected && (
              <span className="absolute -top-1 -right-1 flex size-4 items-center justify-center rounded-full bg-[#a142f4] text-white">
                <Check size={12} strokeWidth={3} aria-hidden />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
